/** 🌍 GLOBAL STANDART KOD (TÜM PROJELER İÇİN GEÇERLİDİR) — tek kaynak Core. */
const requestPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function isNativeAuthRequestId(value: unknown): value is string {
  return typeof value === 'string' && value.length === 36 && requestPattern.test(value);
}

export function readNativeAuthRequest(hash: string): string | null {
  const params = new URLSearchParams(hash.replace(/^#/, ''));
  const request = params.get('native_request');
  return params.size === 1 && isNativeAuthRequestId(request) ? request : null;
}
